(function() {
  function isMobile() {
    return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  }

  function hardenMobileProductPage() {
    if (!isMobile()) return;
    if (!/^\/products\//.test(window.location.pathname)) return;

    document.documentElement.classList.add('bgtcg-mobile-product-stable');
    ensureMobileStyles();

    document.querySelectorAll('product-modal.product-media-modal').forEach(function(modal) {
      modal.remove();
    });

    document.querySelectorAll('.product__modal-opener, .product__media-toggle').forEach(function(trigger) {
      trigger.removeAttribute('data-modal');
      trigger.setAttribute('aria-haspopup', 'false');
    });

    document.querySelectorAll('.product__media img').forEach(function(img, index) {
      img.setAttribute('decoding', 'async');
      if (index > 0) {
        img.setAttribute('loading', 'lazy');
        img.setAttribute('fetchpriority', 'low');
      }
    });
  }

  function ensureMobileStyles() {
    if (document.getElementById('bgtcg-mobile-product-stability-style')) return;

    var style = document.createElement('style');
    style.id = 'bgtcg-mobile-product-stability-style';
    style.textContent = [
      '@media (max-width: 749px){',
      'html.bgtcg-mobile-product-stable .product__media-icon,',
      'html.bgtcg-mobile-product-stable .product__media-toggle{display:none!important;}',
      '}'
    ].join('');
    document.head.appendChild(style);
  }

  document.addEventListener('click', function(event) {
    if (!isMobile()) return;
    var modalTrigger = event.target.closest && event.target.closest('.product__modal-opener, .product__media-toggle');
    if (!modalTrigger) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hardenMobileProductPage);
  } else {
    hardenMobileProductPage();
  }

  window.addEventListener('pageshow', hardenMobileProductPage);
})();
